import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";

const FIELDS = { name: "", email: "", company: "", marketplace: "", monthly_revenue: "", message: "" };

export function LeadForm({ compact = false, idPrefix = "lead" }) {
  const [form, setForm] = useState(FIELDS);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please add your name and email.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/leads", form);
      toast.success("Request received — we'll send your free audit shortly.");
      setForm(FIELDS);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-white/[0.04] border border-white/10 rounded-lg px-4 py-3 text-sm text-white placeholder:text-muted outline-none transition-colors focus:border-orange focus:ring-1 focus:ring-orange/60";

  return (
    <form onSubmit={submit} className="space-y-3" data-testid={`${idPrefix}-form`}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input data-testid={`${idPrefix}-name`} className={inputCls} placeholder="Your name *" value={form.name} onChange={set("name")} />
        <input data-testid={`${idPrefix}-email`} className={inputCls} placeholder="Work email *" type="email" value={form.email} onChange={set("email")} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input data-testid={`${idPrefix}-company`} className={inputCls} placeholder="Brand / company" value={form.company} onChange={set("company")} />
        <input data-testid={`${idPrefix}-marketplace`} className={inputCls} placeholder="Marketplace (Amazon, D2C…)" value={form.marketplace} onChange={set("marketplace")} />
      </div>
      {!compact && (
        <>
          <input data-testid={`${idPrefix}-revenue`} className={inputCls} placeholder="Approx. monthly revenue" value={form.monthly_revenue} onChange={set("monthly_revenue")} />
          <textarea data-testid={`${idPrefix}-message`} className={`${inputCls} resize-none`} rows={3} placeholder="What do you want to improve?" value={form.message} onChange={set("message")} />
        </>
      )}
      <button
        data-testid={`${idPrefix}-submit`}
        type="submit"
        disabled={loading}
        className="group inline-flex w-full items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-orange to-magenta px-6 py-3.5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] disabled:opacity-60"
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Get My Free Audit <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></>}
      </button>
    </form>
  );
}
